/**
 * Format khoảng cách thời gian ngắn theo tiếng Việt
 * Ví dụ: "1 phút trước", "Hôm qua", "12/04"
 */
export function formatDistanceToNow(dateStr: string | Date): string {
  const date = typeof dateStr === 'string' ? new Date(dateStr) : dateStr;
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMinutes = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMinutes < 1) return 'vừa xong';
  if (diffMinutes < 60) return `${diffMinutes}p`;
  if (diffHours < 24) return `${diffHours}h`;
  if (diffDays === 1) return 'hôm qua';
  if (diffDays < 7) return `${diffDays} ngày`;

  // Cùng năm → DD/MM, khác năm → DD/MM/YY
  const sameYear = date.getFullYear() === now.getFullYear();
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  return sameYear ? `${dd}/${mm}` : `${dd}/${mm}/${String(date.getFullYear()).slice(-2)}`;
}

/**
 * Format HH:mm DD/MM/YYYY
 */
export function formatShortDateTime(dateStr: string | Date): string {
  const date = typeof dateStr === 'string' ? new Date(dateStr) : dateStr;
  const hh = String(date.getHours()).padStart(2, '0');
  const mi = String(date.getMinutes()).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const now = new Date();
  // Cùng ngày → chỉ hiện giờ phút
  if (date.toDateString() === now.toDateString()) {
    return `${hh}:${mi}`;
  }
  // Trong tuần → thứ + giờ
  const diffDays = Math.floor((now.getTime() - date.getTime()) / 86400000);
  if (diffDays < 7) return `${dd}/${mm} ${hh}:${mi}`;
  return `${dd}/${mm}/${date.getFullYear()} ${hh}:${mi}`;
}
